import React, { Component } from "react";
import { connect } from "react-redux";
import Table from "../table/Table";
import { fetchPendingOrders, getOrderDetailsForForm } from "../../homeActions";
import Paginater from "../table/Paginater";
import { openModal } from "../../../modal/modalActions";
import { Button } from "antd";
import { PermissibleRender } from "@brainhubeu/react-permissible";
import { getUserPermissions } from "../../../../app/common/util/genericUtils";
import MobileOrderActions from "../MobileOrderActions";
import {
  ORDER_LIST_PAGE_SIZE,
  getOrderRowClassName,
  renderOrderNumberCell,
  renderReferenceIdCell,
  renderDateTimeCell,
  renderSourceCell,
  renderCustomerCell,
  renderCoatingCell,
  renderLnamCell,
  renderLabelsCell,
  renderOrderTypeCell,
} from "../table/orderTableCells";

class PendingAuthTab extends Component {
  columns = [
    {
      title: "Order No.",
      dataIndex: "internal_order_id",
      sorter: (a, b) => a.internal_order_id - b.internal_order_id,
      sortDirections: ["ascend"],
      render: (text, record, index) =>
        renderOrderNumberCell(text, record, () =>
          this.props.getOrderDetailsForForm(record.id, index)
        ),
    },
    {
      title: "Reference Id",
      dataIndex: "reference_id",
      render: renderReferenceIdCell,
    },
    {
      title: "Entry Date & Time",
      dataIndex: "received_date",
      render: renderDateTimeCell,
    },
    {
      title: "Coating",
      dataIndex: "coating.value",
      mobileHidden: true,
      render: renderCoatingCell,
    },
    {
      title: "LNAM",
      dataIndex: "lnam.name",
      mobileHidden: true,
      render: renderLnamCell,
    },
    {
      title: "Customer",
      dataIndex: "customer.name",
      mobileHidden: true,
      render: renderCustomerCell,
    },
    {
      title: "Promise Date & Time",
      dataIndex: "promised_date",
      mobileHidden: true,
      render: renderDateTimeCell,
    },
    {
      title: "Transport Mode",
      dataIndex: "dispatch_type.value",
      mobileHidden: true,
      render: (text) =>
        text ? (
          <span className="order-chip order-chip--dispatch">{text}</span>
        ) : (
          <span className="order-cell-muted">—</span>
        ),
    },
    {
      title: "Order Source",
      dataIndex: "source",
      mobileHidden: true,
      render: renderSourceCell,
    },
    {
      title: "Labels",
      width: 150,
      mobileHidden: true,
      render: renderLabelsCell,
    },
    {
      title: "Entered By",
      dataIndex: "received_by",
      mobileHidden: true,
      render: (text) =>
        text ? (
          <span className="order-entered-by">{text}</span>
        ) : (
          <span className="order-cell-muted">—</span>
        ),
    },
    {
      title: "Type",
      dataIndex: "is_stock",
      mobileHidden: true,
      render: renderOrderTypeCell,
    },
    {
      title: "Actions",
      fixed: "right",
      width: 100,
      className: "order-actions-column",
      render: (text, record) => {
        const userPermissions = getUserPermissions();
        return (
          <MobileOrderActions>
            <PermissibleRender
              userPermissions={userPermissions}
              requiredPermissions={["can_add_label"]}
            >
              <Button
                className="order-action-btn"
                size="small"
                type="primary"
                onClick={() =>
                  this.props.openModal("CreateLabelModal", { id: record.id })
                }
              >
                Add Label
              </Button>
            </PermissibleRender>
            <PermissibleRender
              userPermissions={userPermissions}
              requiredPermissions={["can_link_order"]}
            >
              <Button
                className="order-action-btn"
                size="small"
                type="primary"
                onClick={() =>
                  this.props.openModal("LinkedOrderModal", {
                    type: "linkOldOrder",
                    linkingOrderId: record.id,
                  })
                }
              >
                Link Order
              </Button>
            </PermissibleRender>
          </MobileOrderActions>
        );
      },
    },
  ];

  render() {
    const { loading, orders, fetchPendingOrders } = this.props;
    const results = (orders && orders.results) || [];
    const total = (orders && orders.count) || 0;

    return (
      <div className="home-order-tab-pane">
        <Table
          columns={this.columns}
          loading={loading}
          data={results}
          rowClassName={getOrderRowClassName}
          pagination={false}
          bordered={false}
          size="middle"
        />
        <Paginater
          defaultCurrent={1}
          total={total}
          onChange={fetchPendingOrders}
          pageSize={ORDER_LIST_PAGE_SIZE}
        />
      </div>
    );
  }
}

const actions = {
  fetchPendingOrders,
  getOrderDetailsForForm,
  openModal,
};

const mapStateToProps = (state) => ({
  loading: state.home.loadingPendingAuthOrders,
  orders: state.home.pendingAuthOrders,
  orderDetailsLoading: state.home.orderDetailsLoading,
  activeTabKey: state.home.activeTabKey,
});

export default connect(
  mapStateToProps,
  actions
)(PendingAuthTab);
